<template>
    <div :class="$style.view">
        <div v-if="fetching" :class="$style.loading">
            <div :class="$style.progress">
                <div></div>
            </div>
            <span>{{ $t("headlines.loading") }}...</span>
        </div>

        <div v-else-if="error" :class="$style.error">
            <h1>404</h1>
            <h2>{{ $t("headlines.notfound_collection") }}</h2>
        </div>

        <div v-else :class="$style.event">
            <div
                :class="$style.info"
                :style="{
                    backgroundImage: `url(//player.facecast.net/f/${data.folder}/${data.image}-preview19.${data.ext})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundOrigin: 'border-box',
                    backgroundPosition: 'center center',
                }"
            >
                <div :class="$style.backdrop">
                    <h1>{{ $t("headlines.collection") }} "{{ data.name }}"</h1>
                    <ul :class="$style.list">
                        <li v-for="item in data.events" :key="item.event_id" :class="$style.list_item">
                            {{ item.name }}
                        </li>
                    </ul>
                    <h2 :class="$style.collectionDescription">{{ data.description }}</h2>
                    <div :class="$style.price">
                        <h4 :class="$style.price_ticket">{{ $t("headlines.price_ticket") }}&nbsp;</h4>
                        <div>
                            <h4 :class="$style.price_ticket">{{ ticket_price_online }} &#8381;</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="$style.form">
                <Form type="collections" :id="$route.params.id"></Form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Form from "../components/Form";

export default {
    name: "Event",

    components: {
        Form,
    },

    mounted() {
        const id = this.$route.params.id;

        this.$store.dispatch("data/fetchData", { type: "collections", id }).catch(() => {
            // this.$route.replaceView(() => import(/* webpackChunkName: 'collection' */ '../views/404.vue'))
        });
    },

    methods: {
        close() {
            this.isPriceChanged = false;
        },

        async pay() {
            const id = this.$route.params.id;

            await this.$store.dispatch("form/submitData", { type: "events", id, data: this.$store.state.data.lastDataForm });

            this.close();
        },

        ...mapActions("data", ["submitData"]),
    },

    computed: {
        ...mapState("data", ["data", "fetching", "error", "foreign_payment"]),
        priceUSD: function() {
            return this.data && Number(this.data.ticket_price_usd) && Number(this.data.ticket_price_usd).toFixed(2);
        },
        priceEUR: function() {
            return this.data && Number(this.data.ticket_price_eur) && Number(this.data.ticket_price_eur).toFixed(2);
        },
        ticket_price_online: function () {
            return !this.foreign_payment ? this.data.ticket_price_online : this.data.ticket_price_online_foreign
        },
    },
};
</script>

<style module>
.collectionDescription {
    white-space: pre-wrap;
}

.view {
    width: 100%;
    min-height: 100vh;
}

.list {
    list-style-type: none;
}

.list > li {
    margin-top: 12px;
    margin-bottom: 12px;
    font-weight: 400;
}

.list_item {
    font-size: 24px;
}

.loading {
    composes: view;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.loading > span {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 300;
    letter-spacing: 1px;
    display: block;
    margin-top: 12px;
}

.price_ticket {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
}

.progress {
    position: relative;
    height: 4px;
    display: block;
    max-width: 680px;
    width: 100%;
    background-color: #96c5fd;
    border-radius: 2px;
    background-clip: padding-box;
    margin: 0.5rem 0 1rem 0;
    overflow: hidden;
}

.progress > div {
    background-color: #005bca;
}

.progress > div::before {
    content: "";
    position: absolute;
    background-color: inherit;
    top: 0;
    left: 0;
    bottom: 0;
    will-change: left, right;
    animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
}

.progress > div::after {
    content: "";
    position: absolute;
    background-color: inherit;
    top: 0;
    left: 0;
    bottom: 0;
    will-change: left, right;
    animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
    animation-delay: 1.15s;
}

.error {
    composes: view;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.error > h1 {
    font-size: 56px;
}

.error > h2 {
    font-size: 36px;
    font-weight: 400;
}

@keyframes indeterminate {
    0% {
        left: -35%;
        right: 100%;
    }

    60% {
        left: 100%;
        right: -90%;
    }

    100% {
        left: 100%;
        right: -90%;
    }
}

@keyframes indeterminate-short {
    0% {
        left: -200%;
        right: 100%;
    }

    60% {
        left: 107%;
        right: -8%;
    }

    100% {
        left: 107%;
        right: -8%;
    }
}

.event {
    display: flex;
    height: 100%;
}

.info {
    width: 50%;
    position: relative;
}

.form {
    width: 50%;
    padding: 24px 56px;
    box-shadow: 1px 0px 0 0 hsl(225, 5%, 85%), 0 0 0 1px hsl(228, 10%, 90%);
    min-height: 100vh;
    box-sizing: border-box;
}

.backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    padding: 24px 112px;
    box-sizing: border-box;
}

.backdrop > h1 {
    font-size: 32px;
    font-weight: 400;
    color: rgb(65, 65, 255);
    z-index: 10;
}

.backdrop > h2 {
    font-size: 18px;
    font-weight: 400;
    margin-top: 32px;
    z-index: 10;
    word-break: break-word;
    line-height: 1.4;
}

.backdrop h3 {
    font-size: 36px;
    font-weight: 400;
    margin: 0;
}

.backdrop h5 {
    font-size: 20px;
    color: #000;
    opacity: 0.7;
    font-weight: 400;
    margin: 0;
    padding: 1px 0 0 0;
}

.form {
    width: 50%;
    padding: 24px 56px;
}

.form__content {
    max-width: 600px;
    width: 100%;
}

.field {
    width: 100%;
}

.field:not(:last-child) {
    margin-bottom: 36px;
}

.field > label {
    font-size: 16px;
    display: block;
}

.field > input {
    display: block;
    margin-top: 12px;
    font-size: 16px;
    border: none;
    height: 56px;
    background-color: #eee;
    border-radius: 4px;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    font-family: inherit;
}

.price {
    display: flex;
    justify-content: flex-start;
    padding: 0;
    margin: 56px 0 0 0;
}

.price div {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0;
    margin: 0;
}

.submit {
    background-color: rgb(65, 65, 255);
    border: none;
    width: 100%;
    color: rgb(255, 255, 255);
    font-family: inherit;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    border-radius: 4px;
    cursor: pointer;
}

.select {
    margin-bottom: 36px;
}

.select > label {
    font-size: 16px;
    display: block;
}

.select > select {
    appearance: none;
    display: block;
    margin-top: 12px;
    font-size: 16px;
    border: none;
    height: 56px;
    background-color: #eee;
    border-radius: 4px;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    font-family: inherit;
}

@media all and (max-width: 1212px) {
    .price {
        flex-direction: column;
    }

    .price div {
        align-items: flex-start;
    }
}

@media all and (max-width: 768px) {
    .event {
        flex-direction: column;
    }

    .info {
        width: 100%;
    }

    .backdrop {
        padding: 24px 56px;
    }

    .form {
        width: 100%;
        max-width: none;
        min-height: auto;
    }
}

@media screen and (max-width: 768px) {
    .list {
        padding: 0;
    }

    .backdrop {
        padding: 16px;
    }

    .form {
        padding: 16px;
    }
}
</style>
